var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPhoto(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 71,
    height: 76,
    viewBox: "0 0 71 76",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 71,
    height: 76,
    fill: "#3678f7"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)",
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M68.269,70.542H2.731a2.729,2.729,0,1,0,0,5.458H68.269a2.729,2.729,0,1,0,0-5.458m-17.8-38.667a2.13,2.13,0,0,0,2.211.4l15.654-7.9a.924.924,0,0,0,.257-1.575L46.1.334a.928.928,0,0,0-1.578.252L36.585,16.2a2.127,2.127,0,0,0,.4,2.206ZM3.1,61.623a1.369,1.369,0,0,0,1.931,0L15.441,51.212a6.253,6.253,0,0,0,1.8-3.692,3.665,3.665,0,1,1,4.093,4.087,6.338,6.338,0,0,0-3.7,1.8L7.223,63.818a1.372,1.372,0,0,0,0,1.929l.441.441a2.232,2.232,0,0,0,2.228.453l22.092-9.173a3.67,3.67,0,0,0,1.989-1.532L45.68,35.04a1.916,1.916,0,0,0-.3-2.156l-9.4-9.4a1.913,1.913,0,0,0-2.156-.3L12.91,34.89a3.679,3.679,0,0,0-1.529,1.989L2.205,58.952a2.228,2.228,0,0,0,.452,2.228Z",
    transform: "translate(0 0)",
    fill: "#3678f7"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoto);
export default __webpack_public_path__ + "static/media/photo.a70ec7644c28079f6012260671c89127.svg";
export { ForwardRef as ReactComponent };